<template>
  <div class="bg-white rounded-lg shadow-sm divide-y divide-gray-200">
    <div class="p-4 md:p-8 flex max-md:flex-col gap-6">
      <div class="w-full md:w-1/4">
        <img
          :src="path.coverImage"
          :alt="path.title"
          aria-hidden="true"
          class="object-contain w-[200px] mx-auto"
        >
      </div>

      <div class="flex flex-col gap-4 w-full md:w-3/4">
        <a
          :href="pathUrl(path)"
          class="link link--blue hover:underline"
        >
          <h2 class="text-3xl flex gap-2.5 items-baseline">
            <SvgIcon
              aria-hidden="true"
              icon-name="signs-post"
              class="shrink-0"
              width="16"
              height="16"
            />
            {{ path.title }}
          </h2>
        </a>
        <div class="prose">
          <div v-html="path.summary" />

          <a :href="pathUrl(path)">
            <span>Read more...</span>
            <span class="sr-only">about {{ path.title }}</span>
          </a>
        </div>
        <div class="flex flex-wrap gap-2">
          <a
            :href="appUrl('signin')"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn--sm btn--primary"
          >
            Log In to Assign
          </a>
          <a
            :href="appUrl('signup')"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn--sm btn--secondary"
          >
            Sign Up Today
          </a>
        </div>
      </div>
    </div>

    <details>
      <summary class="flex gap-2 px-4 pt-4 md:px-8 pb-5 items-center text-blue-600 hover:text-blue-800 cursor-pointer">
        <h3>Details</h3>
        <SvgIcon
          aria-hidden="true"
          icon-name="angle"
          class="shrink-0"
          width="16"
          height="16"
        />
      </summary>
      <div class="px-4 pb-6 md:px-8 md:pb-8 text-gray-800">
        <dl class="border border-gray-200 p-4 md:pt-5 md:px-6 md:pb-6 rounded-lg flex flex-col gap-4 text-gray-800">
          <DetailRow
            v-if="path.language"
            :record-type="RecordType.Path"
            icon="globe"
            label="Language:"
          >
            <span v-text="path.language" />
          </DetailRow>
          <DetailRow
            v-if="path.visibleTo.length"
            :record-type="RecordType.Path"
            icon="computer-mouse"
            label="One-Click Assign:"
          >
            <span
              v-for="item in path.visibleTo"
              :key="item"
              :record-type="RecordType.Path"
              class="block after:content-[','] last:after:content-none"
            >
              {{ item }}
            </span>
          </DetailRow>
          <DetailRow 
            v-if="path.difficultyLevel"
            icon="dial"
            label="Ability:"
          >
            <span v-text="path.difficultyLevel" />
          </DetailRow>
        </dl>
      </div>
    </details>
  </div>
</template>

<script lang="ts">
export default { name: 'PathCard' }
</script>

<script setup lang="ts">
import { appUrl, pathUrl } from '~/lib/url'

import { PathRecord } from '~/types/records/PathRecord'
import { RecordType } from '~/types/records/RecordType'

import DetailRow from '~/components/externalContent/DetailRow.vue'

defineProps<{
  path: PathRecord,
}>()
</script>
